// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { initialState, TimesheetState } from './state';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';


/**
 * This effect is for listen form actions, execute form service call and dispatch in form reducer.
 * For form api call purpose.
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 01-05-2020(Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>)  created form effect
 */
export function reducer(state = initialState, action: Actions | AuthActions): TimesheetState {
  switch (action.type) {
    // form COMMON METHOD
    case ActionTypes.TIMESHEET_COMMON: {
      return state;
    }
    // form Success COMMON METHOD
    case ActionTypes.TIMESHEET_COMMON_SUCCESS: {
      // commonly store and handle all form modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }
    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }

    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }

    // DEFAULT
    default:
      return state;
  }
}
